<!-- 地图 -->
<style lang="stylus" scoped>
.center {
  height: 100%;
  padding: 5px;
  background-size: 100% 100%;

  .describe {
    display: flex;
    justify-content: space-between;
    color: #fff;
    text-align: center;
    margin-top: 3vh;
    margin-bottom: 2vh;
    padding: 20px;

    .left, .right {
      width: 50%;
    }

    .title {
      // width: 14.3vh;
      height: 4.2vh;
      line-height: 4.2vh;
      // margin: 2vh auto;
      // font-size: 1.8vh;
      // font-weight: bold;
      font-size: 24px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }

    .number2 {
      height: 33px;
      font-size: 36px;
      font-weight: 400;
      color: rgba(1, 255, 246, 1);
      line-height: 28px;
      text-align: center;
      height: 4.2vh;
      line-height: 4.2vh;
    }

    .number1 {
      height: 33px;
      font-size: 36px;
      font-weight: 400;
      color: rgba(255, 171, 25, 1);
      line-height: 28px;
      text-align: center;
      height: 4.2vh;
      line-height: 4.2vh;
    }

    .detail {
      display: flex;

      .item {
        width: 100%;
      }
    }
  }

  .map {
    width: 774px;
    height: 619px;
    position: relative;
    // border: 1px solid #FFF;
    margin: 0 auto;
    background: url('../../../../../assets/img/ljc/map.png');
    background-size: 100% 100%;

    .item {
      width: 40px;
      height: 40px;
      background: greenyellow;
      border-radius: 50%;

      .item1 {
        width: 50px;
        height: 50px;
        background: red;
        border-radius: 50%;
        animation: load 2s ease-in-out infinite;
      }
    }
  }
}

@keyframes warn {
  0% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0;
  }

  25% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0.1;
  }

  50% {
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
    opacity: 0.3;
  }

  75% {
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    opacity: 0.5;
  }

  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0;
  }
}

@keyframes warn1 {
  0% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0;
  }

  25% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0.1;
  }

  50% {
    transform: scale(0.3);
    -webkit-transform: scale(0.3);
    opacity: 0.3;
  }

  75% {
    transform: scale(0.5);
    -webkit-transform: scale(0.5);
    opacity: 0.5;
  }

  100% {
    transform: scale(0.8);
    -webkit-transform: scale(0.8);
    opacity: 0;
  }
}

.container {
  position: relative;
  width: 120px;
  height: 120px;
  left: 100px;
  top: 190px;
}

.container1 {
  position: relative;
  width: 120px;
  height: 120px;
  left: 200px;
  top: 230px;
}

.container2 {
  position: relative;
  width: 120px;
  height: 120px;
  left: 350px;
  top: -100px;
}

.container3 {
  position: relative;
  width: 120px;
  height: 120px;
  left: 560px;
  top: -100px;
}

.top {
  position: relative;
  width: 86px;
  height: 40px;
  left: 95px;
  top: 90px;
  font-size: 20px;
  line-height: 35px;
  font-weight: 400;
  text-align: right;
  padding-right: 5px;
  color: rgba(255, 255, 255, 1);
  background: url('../../../../../assets/img/ljc/Shape12.png');
  background-size: 100% 100%;

  span {
    position: absolute;
    left: 5px;
    top: 5px;
    width: 25px;
    height: 22px;
    background: url('../../../../../assets/img/ljc/people.png');
    background-size: 100% 100%;
  }
}

/* 保持大小不变的小圆点 */
.dot {
  position: absolute;
  width: 11px;
  height: 11px;
  left: 132px;
  top: 132px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border: 1px solid #33ccff;
  border-radius: 50%;
  background-color: #33ccff; /* 实心圆 ，如果没有这个就是一个小圆圈 */
  z-index: 2;
}

/* 产生动画（向外扩散变大）的圆圈 第一个圆 */
.pulse {
  position: absolute;
  width: 39px;
  height: 39px;
  left: 118px;
  top: 118px;
  border: 1px solid #3399ff;
  background: #33ccff;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  -webkit-animation: warn 2s ease-out;
  -moz-animation: warn 2s ease-out;
  animation: warn 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  box-shadow: 1px 1px 30px #3399ff; /* 阴影效果 */
}

/* 产生动画（向外扩散变大）的圆圈 第二个圆 */
.pulse1 {
  position: absolute;
  width: 39px;
  height: 39px;
  left: 118px;
  top: 118px;
  border: 1px solid #3399ff;
  background: #33ccff;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: 1;
  opacity: 0;
  -webkit-animation: warn1 2s ease-out;
  -moz-animation: warn1 2s ease-out;
  animation: warn1 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  box-shadow: 1px 1px 30px #3399ff; /* 阴影效果 */
}
</style>

<template>
  <div>
    <div class="center">
      <div class="describe">
        <div class="item">
          <div class="title">党员</div>
          <div class="number1">29人</div>
        </div>
        <div class="item">
          <div class="title">本月党员学习</div>
          <div class="number2">5次</div>
        </div>
        <div class="item">
          <div class="title">本月处理村务</div>
          <div class="number1">152项</div>
        </div>
        <div class="item">
          <div class="title">本月发放补贴</div>
          <div class="number2">7304元</div>
        </div>
      </div>
      <div class="map">
        <div class="container">
          <div class="top"><span></span>103户</div>
          <div class="dot"></div>
          <div class="pulse"></div>
          <div class="pulse1"></div>
        </div>
        <div class="container1">
          <div class="top"><span></span>86户</div>
          <div class="dot"></div>
          <div class="pulse"></div>
          <div class="pulse1"></div>
        </div>
        <div class="container2">
          <div class="top"><span></span>124户</div>
          <div class="dot"></div>
          <div class="pulse"></div>
          <div class="pulse1"></div>
        </div>
        <div class="container3">
          <div class="top"><span></span>68户</div>
          <div class="dot"></div>
          <div class="pulse"></div>
          <div class="pulse1"></div>
        </div>
      </div>
      <centerBottom></centerBottom>
    </div>
  </div>
</template>

<script>
import config from '../../../../../../static/config/config';
import centerBottom from './centerBottom'
import './LeftMassif/index.css'
import './LeftMassif/MassifItem/index.css'

import './RightMassif/index.less'
import './RightMassif/MassifItem/index.less'

class MassifItem {
  list = [];
  type = 'left';

  constructor(theme, text = '', name = '', index) {
    this.theme = theme;
    this.text = text;
    this.name = name;
    this.index = index
  }

  setMassif(massif) {
    this.massif = massif;
    return this;
  }

  setList(list) {
    this.list = list;
    return this;
  }

  getStyle() {
    const style = {};
    return style;
  }

  getThemeIndex() {
    return this.list.filter(item => {
      return item.theme === this.theme;
    }).indexOf(this);
  }

  getClassName() {
    const themeIndex = this.getThemeIndex();
    return classNames(
      `theme-${this.theme}`,
      `theme-index-${themeIndex}`
    );
  }
}
const list = [
  new MassifItem(1, '', 'D10', 0),
  new MassifItem(1, '', 'D09', 1),
  new MassifItem(1, '', 'D08', 2),
  new MassifItem(1, '', 'D07', 3),
  new MassifItem(1, '', 'D06', 4),
  new MassifItem(1, '', 'D05', 5),
  new MassifItem(1, '', 'D04', 6),
  new MassifItem(1, '', 'D03', 7),
  new MassifItem(1, '', 'D02', 8),
  new MassifItem(1, '', 'D01', 9),
  //
  new MassifItem(2, '', '16-1', 0),
  new MassifItem(2, '', '16-3', 1),
  new MassifItem(2, '', '16-5', 2),
  new MassifItem(2, '', '16-7', 3),
  new MassifItem(2, '', '16-9', 4),
  new MassifItem(2, '', '16-11', 5),
  new MassifItem(2, '', '16-2', 6),
  new MassifItem(2, '', '16-4', 7),
  new MassifItem(2, '', '16-6', 8),
  new MassifItem(2, '', '16-8', 9),
  new MassifItem(2, '', '16-10', 10),
  new MassifItem(2, '', '16-12', 11),
  //
  new MassifItem(3, '', '', 0),
  new MassifItem(3, '', '', 1),
  //
  new MassifItem(4, '15', '15号棚', 0),
  new MassifItem(5, '', '', 1),
  //
  new MassifItem(6, '', '14号棚', 0),
  new MassifItem(6, '', '13号棚', 1),
  //
  new MassifItem(7, '', '12号棚', 1),
  new MassifItem(8, '', '11号棚', 0),
  new MassifItem(8, '', '9号棚', 1),
  new MassifItem(8, '', '3号棚', 2),
  new MassifItem(8, '', '8号棚', 3),
  new MassifItem(8, '', '2号棚', 4),
  new MassifItem(8, '', '7号棚', 5),
  new MassifItem(8, '', '1号棚', 6),
  //
  new MassifItem(9, '', '10号棚', 0),
  new MassifItem(10, '', '', 1),
  //
  new MassifItem(11, '', '6号棚', 0),
  new MassifItem(11, '', '5号棚', 1),
  new MassifItem(11, '', '4号棚', 2),
  //
  new MassifItem(12, '', '', 0),
  new MassifItem(13, '', '', 1),
  new MassifItem(14, '', '', 2),
  //
  new MassifItem(15, '', '展-2A', 0),
  new MassifItem(15, '', '展-2C', 1),
  //
  new MassifItem(16, '', '展-2B', 0),
  new MassifItem(16, '', '展-2D', 1),
  //
  new MassifItem(17, '', '展-叶菜区', 0),
  new MassifItem(17, '', '展-叶菜区', 1)
];
const rightlist = [
  new MassifItem(null),
  new MassifItem(15, '15', '581-15'),
  new MassifItem(16, '16', '581-16'),
  new MassifItem(14, '14', '581-14'),
  new MassifItem(17, '17', '581-17'),
  new MassifItem(13, '13', '581-13'),
  new MassifItem(18, '18', '581-18'),
  new MassifItem(12, '12', '581-12'),
  new MassifItem(19, '19', '581-19'),
  new MassifItem(11, '11', '581-11'),
  new MassifItem(20, '20', '581-20'),
  new MassifItem(10, '10', '581-10'),
  new MassifItem(21, '21', '581-21'),
  new MassifItem(9, '9', '581-9'),
  new MassifItem(22, '22', '581-22'),
  new MassifItem(8, '8', '581-8'),
  new MassifItem(23, '23', '581-23'),
  new MassifItem(7, '7', '581-7'),
  new MassifItem(24, '24', '581-24'),
  new MassifItem(6, '6', '581-6'),
  new MassifItem(25, '25', '581-25'),
  new MassifItem(5, '5', '581-5'),
  new MassifItem(26, '26', '581-26'),
  new MassifItem(4, '4', '581-4'),
  new MassifItem(27, '27', '581-27'),
  new MassifItem(3, '3', '581-3'),
  new MassifItem(28, '28', '581-28'),
  new MassifItem(2, '2', '581-2'),
  new MassifItem(29, '29', '581-29'),
  new MassifItem(1, '1', '581-1')
];

export default {
  props: ["productionScale", "outputValue"],
  data() {
    return {
      areaName: '',
      timer: null,
      massifList: [],
      massifListR: [],
      tip: true,
      list: [],
      datalist: [],
      index: 0,
      url: config.fileDomain
    }
  },
  components: {
    centerBottom
  },
  methods: {
    show(val, type) {
      // console.log(type === '1')
      if (type === '1') {
        clearInterval(this.timer);
      }
      this.tip = true
      this.list = val
    },
    tips() {
      clearInterval(this.timer);
      this.tip = true
    },
    leave() {
      this.tip = false;
      this.time()
    },
    time() {
      var count = this.datalist.length
      this.timer = setInterval(() => {
        if (this.index > count) {
          this.index = 0
        }
        this.show(this.datalist[this.index])
        this.index = this.index + 1
        // console.log(this.index)
      }, 3000);
    }
  },
  async mounted() {
    let { err, res } = await this.$model('dataManagement').commonfn2(this.$apiUrl.DATAANALYSIS.GetMassIfInfoStatistic);
    if (res.state === 200) {
      let resultData = res.results
      for (var key in resultData) {
        for (var i = 0; i < list.length; i++) {
          if (key === list[i].name) {
            list[i].setList(resultData[key])
            this.datalist.push(resultData[key])
          }
        }
        for (var j = 0; j < rightlist.length; j++) {
          if (key === rightlist[j].name) {
            rightlist[j].setList(resultData[key])
            this.datalist.push(resultData[key])
          }
        }
      }
      this.massifList = list
      this.massifListR = rightlist
      console.log(this.datalist)
      this.time()
    } else {
      this.$message.showError(err);
    }
    console.log(config.fileDomain)
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?e9cd61c4